import { render, staticRenderFns } from "./Infobulle.vue?vue&type=template&id=420af85a"
import script from "./Infobulle.vue?vue&type=script&lang=js"
export * from "./Infobulle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports